const mapHeroData = (hero = {}) => {
  const data = {};

  data.image = hero?.hero_background;
  data.title = hero?.hero_title;
  data.subtitle = hero?.hero_subtitle;

  return data;
};

const mapHighlightsData = (highlights = {}) => {
  const data = {};

  data.title = highlights?.title;
  data.highlights = highlights?.components?.map(({ title, image }) => ({
    title,
    image,
  }));

  return data;
};

const mapFeaturesData = (features = {}) => {
  const data = {};

  data.title = features?.title;
  data.features = features?.components?.map(({ title }) => ({
    title,
    image: features?.image,
  }));

  return data;
};

const mapFloatingBannerData = (banner = {}) => {
  const data = {};

  data.title = banner?.title;
  data.ctaTitle = banner?.cta_title;

  return data;
};

const mapFormData = (forms = {}, packages = []) => {
  const data = {};

  data.title = forms?.sub_title;
  data.subtitle = forms?.description;

  const services = forms?.services?.find(
    ({ value }) => value === (forms?.service_type || "yoga")
  );
  data.options = services?.slugs?.map(
    ({ label, slug, related_nutrition_goals_ids }) => ({
      label,
      value: slug,
      goalId: related_nutrition_goals_ids?.[0],
    })
  );

  data.defaultPackageSlug = "yoga-for-others-ind-49";
  data.pricing = packages?.[0];

  data.showGiftSection = forms?.show_gift_section;
  data.showNameField = forms?.show_name_field;
  data.namePlaceholder = forms?.name_placeholder;
  data.showPhoneField = forms?.show_phone_field;
  data.mobilePlaceholder = forms?.mobile_placeholder;
  data.showEmailField = forms?.show_email_field;
  data.emailPlaceholder = forms?.email_placeholder;
  data.showGoalField = forms?.show_goal_filed;
  data.goalPlaceholder = forms?.goal_placeholder;
  data.showPromoCodeField =
    forms?.accept_coupon || forms?.show_promo_code_field;
  data.promoCodePlaceholder = forms?.promo_code_placeholder;

  return data;
};

export const mapAnnualMembershipData = (res = {}) => {
  const {
    hero,
    highlights,
    features_and_benefits: features,
    medical_conditions: conditions,
    floating_banner: banner,
    forms,
    package_info: packages,
  } = res;
  const data = {};

  data.hero = mapHeroData(hero);
  data.highlights = mapHighlightsData(highlights);
  data.features = mapFeaturesData(features);
  data.conditions = conditions?.sub_title;
  data.banner = mapFloatingBannerData(banner);
  data.form = mapFormData(forms, packages);

  return data;
};
